// Vendors
import styled from 'styled-components';
import { FoundationsCobrandedRegularTheme } from '@openbank/ziniaweb-ui-core-models';

const RowLisTootltipLabelStyled = styled.div`
  display: flex;
  gap: ${FoundationsCobrandedRegularTheme.spacing_150};
  margin-left: ${FoundationsCobrandedRegularTheme.spacing_150};
`;

RowLisTootltipLabelStyled.displayName = 'RowLisTootltipLabelStyled';

export { RowLisTootltipLabelStyled };
